export * from './access-requirement-data-access-policy.component';
export * from './access-requirement-data-access-policy.module';
